import React, { Component } from 'react';

import Profile from '../../components/Profile/Profile';

class ProfileView extends Component {
  render() {
    const userData = JSON.parse(localStorage.getItem('user'));

    return (
      <Profile data={userData} />
    );
  }
}

export default ProfileView;



// WEBPACK FOOTER //
// ./src/views/Profile/ProfileView.js